export default "__VITE_ASSET__DsKGY9R7__"